import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { MailOutlined, UserOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import api from "Common/Client/Interceptor";
import "./auth.css";

const BASE_URL = process.env.REACT_APP_API_URL;
const API = {
  account: {
    register: `${BASE_URL}/Account/Individual/Register`,
  },
};

const Register = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (values) => {
    setLoading(true);
    try {
      const payload = {
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
      };

      console.log("Registration Payload:", payload);

      const response = await api.post(API.account.register, payload);

      console.log("Full API Response:", response);
      console.log("Response Status:", response.status);
      console.log("Response Data:", response.data);
      console.log("Response Headers:", response.headers);

      if (response.status === 200 || response.status === 201) {
        toast.success("Registration successful! Please check your email for verification.");
        navigate("/registration-success");
      } else {
        toast.warning("Registration completed but may require verification.");
      }
    } catch (error) {
      console.error("Registration error details:", {
        status: error.response?.status,
        data: error.response?.data,
        headers: error.response?.headers,
      });

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.errors?.[0] ||
        "Registration failed!";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ciq-auth">
      {/* Left: brand showcase */}
      <aside className="ciq-auth__brand">
        <div className="ciq-auth__brand-bg" />
        <div className="ciq-auth__brand-inner">
          <a className="ciq-brand" href="https://coreiqpro.com">
            <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="CoreIQPro" />
            <span className="ciq-brand__txt">
              Core<span className="o">IQ</span>Pro
            </span>
          </a>
          <h1 className="ciq-auth__headline">Start learning at your own pace.</h1>
          <p className="ciq-auth__sub">
            Create your account and learn with progress tracking, assessments, and
            certificates you can showcase.
          </p>
          <ul className="ciq-auth__points">
            <li>
              <i className="fas fa-check" /> Free courses to get started
            </li>
            <li>
              <i className="fas fa-check" /> Track your progress and assessments
            </li>
            <li>
              <i className="fas fa-check" /> Earn certificates you can share
            </li>
          </ul>
        </div>
      </aside>

      {/* Right: register form */}
      <main className="ciq-auth__panel">
        <motion.div
          className="ciq-auth__card"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="ciq-auth__card-head">
            <div>
              <h2>Create your account</h2>
              <p className="ciq-auth__muted">Join CoreIQPro as an individual learner</p>
            </div>
          </div>

          <Form name="register-form" layout="vertical" onFinish={handleRegister} requiredMark={false}>
            <Form.Item
              name="firstName"
              label="First name"
              rules={[{ required: true, message: "Please enter your first name!" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="John" size="large" />
            </Form.Item>

            <Form.Item
              name="lastName"
              label="Last name"
              rules={[{ required: true, message: "Please enter your last name!" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Doe" size="large" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Please enter a valid email address!" },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="you@example.com"
                autoComplete="email"
                size="large"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
              <motion.div
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 400, damping: 20 }}
              >
                <Button type="primary" htmlType="submit" block loading={loading} disabled={loading}>
                  {loading ? "Registering..." : "Create account"}
                </Button>
              </motion.div>
            </Form.Item>
          </Form>

          <div className="ciq-auth__foot">
            <span className="ciq-auth__muted">Already have an account?</span>
            <Button type="link" style={{ padding: "0 6px" }} onClick={() => navigate("/login")}>
              Log in
            </Button>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default Register;
